import React, { useEffect, useState, useRef } from 'react';
import {
    AiOutlinePlusCircle,
    AiOutlineDelete,
    AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { Modal, Button, Table, Form } from "react-bootstrap";
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';


const SalesEnquiry = ({ adminData, branchID }) => {
 const searchInputRef = useRef(null);

    // const [showForm, setShowForm] = useState(false);
    const fileInputRef = useRef(null);
    const [attachments, setAttachments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [salesEnquiryList, setSalesEnquiryList] = useState([]);
    const [architectOptions, setArchitectOptions] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [newOptionText, setNewOptionText] = useState("");
    const [showPartyModal, setShowPartyModal] = useState(false);
    const [search, setSearch] = useState("");
    const [partyOptions, setPartyOptions] = useState([]);
    const [inventoryItems, setInventoryItems] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [fetchInquiry, setFetchInquiry] = useState([]);

    const [showArchitectModal, setShowArchitectModal] = useState(false);
    const [newArchitectName, setNewArchitectName] = useState("");
    const [showConsultantModal, setShowConsultantModal] = useState(false);
    const [newConsultantName, setNewConsultantName] = useState("");
    const [consultantOptions, setConsultantOptions] = useState([]);
    const [branchDetail, setBranchDetail] = useState([])



    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [statusOptions, setStatusOptions] = useState([
        { value: "Open", label: "Open" },
        { value: "Pending", label: "Pending" },
        { value: "Closed", label: "Closed" }
    ]);

    const [quotationToOptions, setQuotationToOptions] = useState([
        { value: "Client", label: "Client" },
        { value: "Contractor", label: "Contractor" },
        { value: "Architect", label: "Architect" }
    ]);


    const getTodayDate = () => {
        return new Date().toISOString().split("T")[0];
    };


       

    const [formData, setFormData] = useState({
        partyId: "",
        party: "",
        date: getTodayDate(),
        visite_date: "",
        consultant: "",
        architect: "",
        status: "",
        quotationTo: "",
        salesPerson_db_id: "",
        salesPerson_id: "",
        salesPerson_name: "",
        coordinator_db_id: "",
        coordinator_id: "",
        coordinator_name: "",
        remark: "",
        tableRow: [{ item: "",name:'', qty: "" }],
        attachments: [],
        created_by: '',
        updated_by: '',
    });

    useEffect(() => {
                                    if (showPartyModal) {
                                      setTimeout(() => {
                                        searchInputRef.current?.focus();
                                      }, 100);
                                    }
                                  }, [showPartyModal]);


    const location = useLocation();
    const [showForm, setShowForm] = useState(location.state?.showAddForm || false);
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    // ========================handlers==========================
    const handleSelectChange = (name, selected) => {
        setFormData(prev => ({
            ...prev,
            [name]: selected ? selected.value : ""
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddClick = () => {
        setShowForm(true);
    };

    const addRow = () => {
        setFormData(prev => ({
            ...prev,
            tableRow: [...prev.tableRow, { item: "", name:'', qty: "" }]
        }));
    };


    const deleteRow = (index) => {
        setFormData(prev => ({
            ...prev,
            tableRow: prev.tableRow.filter((_, i) => i !== index)
        }));
    };




    const filtered = partyOptions.filter(
        (p) =>
            p.label.toLowerCase().includes(search.toLowerCase()) ||
            p.phoneList.some((ph) =>
                ph.toLowerCase().includes(search.toLowerCase())
            ) ||
            (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
    );

    const limitText = (text, limit) => {
        if (!text) return "";
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    };

    const reset = () => {
        // Reset after submit
        setFormData({
            partyId: "",
            party: "",
            date: getTodayDate(),
            visite_date: "",
            consultant: "",
            architect: "",
            status: "",
            salesPerson: "",
            coordinator: "",
            remark: "",
            tableRow: [{ item: "",name:'', qty: "" }],
            attachments: []
        });

        setAttachments([]);
        setShowForm(false);
    }

const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const fd = new FormData();

        // Append normal fields
        fd.append("partyId", formData.partyId);
        fd.append("party", formData.party);
        fd.append("date", formData.date);
        fd.append("visite_date", formData.visite_date);
        fd.append("consultant", formData.consultant);
        fd.append("architect", formData.architect);
        fd.append("status", formData.status);
        fd.append("quotationTo", formData.quotationTo);
        fd.append("enquiry_date", formData.enquiry_date);
        fd.append("salesPerson_id", formData.salesPerson_db_id);
        fd.append("coordinator_id", formData.coordinator_db_id);

        // ✅ MERGE REMARKS
        const newRemark = {
            remark: formData.remark,
            // emp_id: adminData.user.emp_id,
             emp_id: adminData.user.id,
    emp_name: [
      adminData.user.first,
      adminData.user.middle,
      adminData.user.last
    ].filter(Boolean).join(" "),
            datetime: new Date().toISOString()
        };

        let fullRemarkHistory = [];

        if (isEditMode) {
            // Merge old + new remark
            fullRemarkHistory = [...(formData.remark_history || []), newRemark];
        } else {
            fullRemarkHistory = [newRemark];
        }

        fd.append("remark_history", JSON.stringify(fullRemarkHistory));

        // Table rows
        fd.append("tableRow", JSON.stringify(formData.tableRow));

        // Attachments
        attachments.forEach((att, i) => {
            fd.append("files", att.file);
            fd.append(`fileRemark_${i}`, att.remark || "");
        });

        if (isEditMode && editingCompanyId) {
            fd.append("oldAttachments", JSON.stringify(formData.attachments || []));
            fd.append("updated_by", adminData.user.id);

            await axios.put(
                `https://api.skyguard.group/api/update-sales-enquiry/${editingCompanyId}`,
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            showToast('Sale Inquiry Updated Successfully!', 'success');
        } else {
            fd.append("created_by", adminData.user.id);

            await axios.post(
                "https://api.skyguard.group/api/add-sales-enquiry",
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            showToast('Sale Inquiry Added Successfully!', 'success');
        }

        // Reset form
        reset();
        fetchInquiryDetail();
        setShowForm(false);
        setAttachments([]);
        setIsEditMode(false);

    } catch (error) {
        console.log(error);
        showToast('Something went wrong!', 'danger');
    }
};

 

    const handleEdit = (form) => {
    const safeParse = (value, fallback = []) => {
        if (!value) return fallback;
        if (Array.isArray(value)) return value;
        try {
            return JSON.parse(value);
        } catch {
            return fallback;
        }
    };

    const savedArchitect = form.architect_name || form.architect;
    if (savedArchitect && !architectOptions.some(opt => opt.value === savedArchitect)) {
        setArchitectOptions(prev => [...prev, { value: savedArchitect, label: savedArchitect }]);
    }

    const savedConsultant = form.consultant || form.consultant;
    if (savedConsultant && !consultantOptions.some(opt => opt.value === savedConsultant)) {
        setConsultantOptions(prev => [...prev, { value: savedConsultant, label: savedConsultant }]);
    }

    const parsedAttachments = JSON.parse(form.attachments || "[]");

    setFormData({
        id: form.id || "",
        partyId: form.party_id || "",
        party: form.party_name || "",
        enquiry_date: form.enquiry_date || '',
        visite_date: form.visite_date?.split("T")[0] || "",
        consultant: savedConsultant || "",
        architect: savedArchitect,
        status: form.status || "",
        quotationTo: form.quotation_to || "",
        salesPerson_db_id: form.sales_person_id || "",
        salesPersonSelect: form.sales_person_id
            ? { value: form.sales_person_id, label: form.sales_person_name }
            : null,
        coordinator_db_id: form.coordinator_id || "",
        coordinatorSelect: form.coordinator_id
            ? { value: form.coordinator_id, label: form.coordinator_name }
            : null,

        // ✅ NEW: Parse old remark history
        remark_history: safeParse(form.remark_history, []),

        // Optional: clear input for new remark
        remark: "",

        tableRow: safeParse(form.table_row, [{ item: "",name:'', qty: "" }]),
        attachments: parsedAttachments,
    });

    setAttachments(parsedAttachments);
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
};

    const fetchPartyDetail = async () => {
        try {
            const resParty = await axios.get("https://api.skyguard.group/api/fetch-party");
            // console.log(resParty);

            const options = resParty.data.map((p) => ({
                party_id: p.id,
                label: p.name,
                phoneList: [
                    p.phone,
                    p.mobile,
                    p.phone_two,
                    p.phone_three,
                    p.contact_no
                ].filter(Boolean),

                address: p.address || "",
            }));


            setPartyOptions(options);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchInventoryDetail = async () => {
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');

            const items = resInventory.data.result || [];
            const options = items.map(item => ({
                value: item.id,
                label: item.name
            }));

            setInventoryItems(options);


        } catch (error) {
            console.log(error);
        }
    };

    const fetchInquiryDetail = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-sales-enquiry');

            // setFetchInquiry(res.data);

              const parsedData = res.data.map(item => ({
            ...item,
            remark_history: JSON.parse(item.remark_history || "[]")
        }));

        setFetchInquiry(parsedData);
           
        } catch (error) {
            console.log(error);
        }
    };

    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            // console.log(data);

            const formatted = data.map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: `${emp.emp_id} - ${fullName}`,
                    empName: fullName,
                }
            });
            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    }
    const fetchBranchDetail = async () => {
        try {
            const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(resInventory.data)
        } catch (error) {
            console.log(error)
        }
    };


    useEffect(() => {
        fetchPartyDetail();
        fetchInventoryDetail();
        fetchEmployeeData();
        fetchInquiryDetail();
        fetchBranchDetail();
    }, [])



    const filteredData = fetchInquiry.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

   const remarkTableData = fetchInquiry
  .filter(pms => pms.id === editingCompanyId)
  .flatMap(pms => {
    let remarksArray = [];

    try {
      remarksArray = Array.isArray(pms.remark_history)
        ? pms.remark_history
        : JSON.parse(pms.remark_history || "[]");
    } catch {
      remarksArray = [];
    }

    return remarksArray.map(r => ({
      adminId: r.emp_id,
      adminName: r.emp_name || "Unknown",
      remark: r.remark || "",
      date: r.datetime || "",
      pmsId: pms.id
    }));
  });



    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />
                    <h3 className='my-3 fw-bold fs-5 golos'>Sales Enquiry</h3>
                    {/* Search and Add */}
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleAddClick}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {/* Form Section */}
                    {showForm && (
                        <div className="card p-3 my-3 shadow-sm bg-white border">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* left side */}
                                    <div className="col-md-6">

                                                                                   {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`SI/${formData.id}/${branchDetail.code}`}
    </span>
  </div>
)}
                                        <div className="row g-3">
                                            {/*Select Party*/}
                                            <div className="col-12">
                                                <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Choose Party..."
                                                    value={formData.party}
                                                    readOnly
                                                    onClick={() => setShowPartyModal(true)}
                                                    required
                                                />
                                            </div>
                                            {/*Consultant*/}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Consultant</label>


                                                <Select
                                                    options={[...consultantOptions, { label: "+ Add Consultant", value: "add_new" }]}
                                                    value={consultantOptions.find(opt => opt.value === formData.consultant) || null}
                                                    onChange={(selected) => {
                                                        if (!selected) return;

                                                        if (selected.value === "add_new") {
                                                            setShowConsultantModal(true);
                                                        } else {
                                                            setFormData(prev => ({ ...prev, consultant: selected.value }));
                                                        }
                                                    }}
                                                />



                                                {showConsultantModal && (
                                                    <div className="modal show d-block" tabIndex="-1">
                                                        <div className="modal-dialog">
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title">Add New Consultant</h5>
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close"
                                                                        onClick={() => setShowConsultantModal(false)}
                                                                    ></button>
                                                                </div>

                                                                <div className="modal-body">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter consultant name"
                                                                        value={newConsultantName}
                                                                        onChange={(e) => setNewConsultantName(e.target.value)}
                                                                    />
                                                                </div>

                                                                <div className="modal-footer">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary"
                                                                        onClick={() => setShowConsultantModal(false)}
                                                                    >
                                                                        Cancel
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => {
                                                                            if (!newConsultantName.trim()) return;

                                                                            const newConsultant = {
                                                                                value: newConsultantName,
                                                                                label: newConsultantName,
                                                                            };

                                                                            // Update options & select it
                                                                            setConsultantOptions(prev => [...prev, newConsultant]);
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                consultant: newConsultant.value,
                                                                            }));

                                                                            // Reset modal
                                                                            setNewConsultantName("");
                                                                            setShowConsultantModal(false);
                                                                        }}
                                                                    >
                                                                        OK
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}



                                            </div>
                                            {/*Sales Person*/}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Sales Person</label>
                                                <Select
                                                    options={employeeList}
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            salesPerson_db_id: selectedOption.id,
                                                            salesPerson_id: selectedOption.value,
                                                            salesPerson_name: selectedOption.empName,
                                                        }))
                                                    }}
                                                    value={
                                                        employeeList.find(opt => String(opt.id) === String(formData.salesPerson_db_id)) || null
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className="row g-3">
                                            <div className='col-12'>
                                                <label htmlFor='date' className="form-label fw-medium"> Date</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    name="enquiry_date"
                                                    id='date'
                                                    value={formData.enquiry_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {/*Architect*/}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Architect</label>


                                                {/* Architect Select */}
                                                <Select
                                                    options={[...architectOptions, { label: "+ Add Architect", value: "add_new" }]}
                                                    value={architectOptions.find(opt => opt.value === formData.architect) || null}
                                                    onChange={(selected) => {
                                                        if (!selected) return;

                                                        if (selected.value === "add_new") {
                                                            setShowArchitectModal(true);
                                                        } else {
                                                            setFormData(prev => ({ ...prev, architect: selected.value }));
                                                        }
                                                    }}
                                                />

                                                {/* Architect Add Modal */}
                                                {showArchitectModal && (
                                                    <div className="modal show d-block" tabIndex="-1">
                                                        <div className="modal-dialog">
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title">Add New Architect</h5>
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close"
                                                                        onClick={() => setShowArchitectModal(false)}
                                                                    ></button>
                                                                </div>
                                                                <div className="modal-body">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter architect name"
                                                                        value={newArchitectName}
                                                                        onChange={(e) => setNewArchitectName(e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary"
                                                                        onClick={() => setShowArchitectModal(false)}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => {
                                                                            if (!newArchitectName.trim()) return;

                                                                            const newArchitect = { value: newArchitectName, label: newArchitectName };

                                                                            // Update architect options and select in form
                                                                            setArchitectOptions(prev => [...prev, newArchitect]);
                                                                            setFormData(prev => ({ ...prev, architect: newArchitect.value }));

                                                                            // Reset modal
                                                                            setNewArchitectName("");
                                                                            setShowArchitectModal(false);
                                                                        }}
                                                                    >
                                                                        OK
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}



                                            </div>
                                            {/* Sales Coordinator */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Sales Coordinator</label>
                                                <Select
                                                    options={employeeList}
                                                    onChange={(selected) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            coordinator_db_id: selected.id,
                                                            coordinator_id: selected.value,
                                                            coordinator_name: selected.empName,
                                                        }))
                                                    }}
                                                    value={
                                                        employeeList.find(opt => String(opt.id) === String(formData.coordinator_db_id)) || null
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive my-4">
                                        <div className="d-flex justify-content-end mb-2 col-md-1">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={addRow}
                                            >
                                                + Add Item
                                            </button>
                                        </div>
                                        <table className="table table-bordered mx-auto text-center align-middle w-75">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Item</th>
                                                    <th>Qty</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData?.tableRow.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            <Select
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                    menu: base => ({ ...base, zIndex: 9999 })
                                                                }}
                                                                options={inventoryItems}
                                                                value={inventoryItems.find(opt => opt.value === formData.tableRow[idx].item) || null}
                                                                placeholder="Select Item"
                                                                onChange={(selected) => {
                                                                    const updated = [...formData.tableRow];
                                                                    updated[idx].item = selected.value;
                                                                    setFormData(prev => ({ ...prev, tableRow: updated }));
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={formData.tableRow[idx].qty || ""}
                                                                onChange={(e) => {
                                                                    const updated = [...formData.tableRow];
                                                                    updated[idx].qty = e.target.value;
                                                                    setFormData(prev => ({ ...prev, tableRow: updated }));
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <button type="button" className="btn btn-danger btn-sm"
                                                                onClick={() => deleteRow(idx)}
                                                            >
                                                                <AiOutlineDelete size={22} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className="row g-3">
                                                <div className='col-12'>
                                                    <label htmlFor='visite_date' className="form-label fw-medium"> Visite Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="visite_date"
                                                        id='visite_date'
                                                        value={formData.visite_date}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label fw-medium">Select Status</label>
                                                    <Select
                                                        options={statusOptions}
                                                        value={statusOptions.find(opt => opt.value === formData.status) || null}
                                                        onChange={(selected) => handleSelectChange("status", selected)}
                                                        isClearable
                                                    />
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="form-label fw-medium">Upload Multiple Attachments</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        multiple
                                                        ref={fileInputRef}
                                                        onChange={(e) => {
                                                            const newFiles = Array.from(e.target.files).map(file => ({
                                                                file,
                                                                remark: ""
                                                            }));

                                                            setAttachments(prev => [...prev, ...newFiles]);

                                                            // Also store in formData
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                attachments: [...prev.attachments, ...newFiles]
                                                            }));

                                                            fileInputRef.current.value = "";
                                                        }}
                                                    />
                                                </div>
                                                {/* Beautiful list */}
                                                {attachments.length > 0 && (
                                                    <div className="mt-3">
                                                        <label className="fw-medium d-block mb-2">Attached Files</label>
                                                        <div className="list-group shadow-sm">
                                                            {attachments.map((att, idx) => (
                                                                <div key={idx} className="list-group-item">

                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="badge bg-primary me-2">{idx + 1}</span>
                                                                            <span>{att.file?.name || att.file_name}</span>

                                                                        </div>

                                                                        <button
                                                                            className="btn btn-sm btn-outline-danger"
                                                                            onClick={() => {
                                                                                const updated = attachments.filter((_, i) => i !== idx);
                                                                                setAttachments(updated);

                                                                                //  Also update formData
                                                                                setFormData(prev => ({
                                                                                    ...prev,
                                                                                    attachments: updated
                                                                                }));
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                    </div>

                                                                    <input
                                                                        type="text"
                                                                        className="form-control mt-2"
                                                                        placeholder="Add remark..."
                                                                        value={att.remark || ""}
                                                                        onChange={(e) => {
                                                                            const updated = [...attachments];
                                                                            updated[idx].remark = e.target.value;
                                                                            setAttachments(updated);

                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                attachments: updated
                                                                            }));
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row g-3'>
                                                <div className="col-12">
                                                    <label className="form-label fw-medium">Select Quotation To</label>
                                                    <Select
                                                        options={quotationToOptions}
                                                        value={quotationToOptions.find(opt => opt.value === formData.quotationTo) || null}
                                                        onChange={(selected) => handleSelectChange("quotationTo", selected)}
                                                        isClearable
                                                    />
                                                </div>
                                                <div className='col-12'>
                                                    <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="remark"
                                                        id='remark'
                                                        placeholder="Enter here..."
                                                        value={formData.remark}
                                                        onChange={handleChange}
                                                        rows="10"
                                                    />
                                                </div>

   


                                            </div>

                      
                                        </div>

                                                                                     <div className="table-responsive">
    <table className="table table-bordered">
      <thead className="table-light">
        <tr>
          <th>Employee Name</th>
          <th>Date</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {remarkTableData.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No remarks found</td>
          </tr>
        ) : (
          remarkTableData.map((item, index) => (
            <tr key={index}>
              <td>{item.adminName}</td>
              <td>{new Date(item.date).toLocaleDateString()}</td>
              <td style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                {item.remark}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
                       
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center mt-5 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-danger'

                                        onClick={() => {
                                            setShowForm(false);
                                            setIsEditMode(false);
                                            reset();
                                        }}
                                    >
                                        Cancel
                                    </button>

                                </div>
                            </form>
                        </div>
                    )}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                       <th>Action</th>
                                    <th>Ref Doc</th>
                                    <th>Party</th>
                                    <th>Status</th>
                                    <th>Created By </th>
                                    <th>Created At</th>
                                    <th>Last Updated By</th>
                                    <th>Last Updated At</th>
                                 
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={item.index}>
                                               <td>
                                            <button
                                                className="btn btn-sm btn-warning"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <AiOutlineEdit size={18} />
                                            </button>
                                        </td>
                                        {/* <td>{`${branchDetail?.code}/SI/${item.id}`}</td> */}
                                        <td>{`SI/${item.id}/${branchDetail?.code}`} </td>
                                        <td>{item.party_name} </td>
                                        <td>{item.status} </td>
                                        <td>{item.add_employee_name} {item.add_employee_middle_name} {item.add_employee_last_name} </td>
                                              <td>{item.enquiry_date} </td>
                                        <td>{item.edit_employee_name} {item.edit_employee_middle_name} {item.edit_employee_last_name} </td>
                                        <td>{item.updated_at} </td>

                                 
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {showAddModal && (
                <div className="modal-backdrop-custom">
                    <div className="modal-card">
                        <h5>Add {modalType === "consultant" ? "Consultant" : "Architect"}</h5>

                        <input
                            type="text"
                            className="form-control my-2"
                            value={newOptionText}
                            onChange={(e) => setNewOptionText(e.target.value)}
                            placeholder="Enter name..."
                        />

                        <div className="mt-3 d-flex gap-2">
                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    if (modalType === "consultant") {
                                        setConsultantOptions(prev => [
                                            ...prev,
                                            { label: newOptionText, value: newOptionText }
                                        ]);
                                    } else {
                                        setArchitectOptions(prev => [
                                            ...prev,
                                            { label: newOptionText, value: newOptionText }
                                        ]);
                                    }
                                    setNewOptionText("");
                                    setShowAddModal(false);
                                }}
                            >
                                Save
                            </button>

                            <button className="btn btn-danger" onClick={() => setShowAddModal(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Inline Modal */}
            <Modal
                show={showPartyModal}
                onHide={() => setShowPartyModal(false)}
                size="lg"
                centered
                dialogClassName="party-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">🔍 Search Party</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {/* Search Bar */}
                    <div className="mb-3">
                        <Form.Control
                            type="text"
                            className="search-box"
                            placeholder="Search party by name, phone, or address..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            ref={searchInputRef}
                        />
                    </div>

                    {/* Responsive Table */}
                    <div className="table-wrapper shadow-sm rounded">
                        <Table hover className="party-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filtered.map((p) => (
                                    <tr key={p.value} className="row-hover">
                                        <td>{p.label}</td>

                                        {/* PHONE  */}
                                        <td
                                            className="truncate"
                                            title={p.phoneList.join(", ")}
                                        >
                                            {limitText(p.phoneList.join(", "), 20)}
                                        </td>

                                        {/* ADDRESS  */}
                                        <td
                                            className="truncate"
                                            title={p.address}
                                        >
                                            {limitText(p.address, 30)}
                                        </td>


                                        {/* SELECT BUTTON */}
                                        <td className="text-center">
                                            <Button
                                                className="select-btn"
                                                onClick={() => {
                                                    // const maskedPhones = p.phoneList
                                                    //     .map(ph => maskPhone(ph))
                                                    //     .join(", ");

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        partyId: p.party_id,
                                                        party: p.label,
                                                        // maskedContacts: maskedPhones
                                                    }));

                                                    setShowPartyModal(false);
                                                }}
                                            >
                                                Select
                                            </Button>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SalesEnquiry